import {createStore, createLogger} from 'vuex'
import cart from './modules/cart'
import toasts from "./modules/toasts"
import auth from './modules/auth'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    modules: {
        cart,
        toasts,
        auth,
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
